import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

//stessa resa di NW4: i Boolean sono un'icona sì/no e i Rating una fila di stelle,
//mai il valore testuale ("true"/"false" finirebbe così com'è nel package del cliente)
const ModelFeatureValue = ({ feature, children }) => {
    if (feature.type === 'Boolean') {
        const isTrue = String(feature.value).toLowerCase() === 'true';
        return (
            <FontAwesomeIcon
                className={isTrue ? 'model-feature-bool-true' : 'model-feature-bool-false'}
                icon={isTrue
                    ? icon({ family: 'sharp', style: 'solid', name: 'check' })
                    : icon({ family: 'sharp', style: 'solid', name: 'ban' })
                }
            />
        );
    }

    if (feature.type === 'Rating') {
        const rating = parseInt(feature.value, 10);
        if (!rating || rating < 1) {
            return null;
        }
        return (
            <>
                {Array.from({ length: rating }, (_, index) => (
                    <FontAwesomeIcon
                        key={`star-${index}`}
                        className="model-feature-rating-star"
                        icon={icon({ family: 'sharp', style: 'solid', name: 'star' })}
                    />
                ))}
            </>
        );
    }

    return children;
};

export default ModelFeatureValue;
